export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-industrial-f16b859986c6928dc4efec1a93f6bed4.jpg";